export type CookiePreferences = {
  essential: boolean;
  analytics: boolean;
  marketing: boolean;
};

const COOKIE_CONSENT_KEY = 'cookieConsent';

export const getDefaultPreferences = (): CookiePreferences => ({
  essential: true, // Always true, essential cookies can't be disabled
  analytics: false,
  marketing: false,
});

export const getCookieConsent = (): CookiePreferences | null => {
  const stored = localStorage.getItem(COOKIE_CONSENT_KEY);
  if (!stored) return null;
  
  try {
    return JSON.parse(stored);
  } catch {
    return null;
  }
};

export const setCookieConsent = (preferences: CookiePreferences): void => {
  localStorage.setItem(COOKIE_CONSENT_KEY, JSON.stringify(preferences));
};

export const hasAnalyticsConsent = (): boolean => {
  const consent = getCookieConsent();
  return consent?.analytics ?? false;
};

export const hasMarketingConsent = (): boolean => {
  const consent = getCookieConsent();
  return consent?.marketing ?? false;
};

export const clearCookieConsent = (): void => {
  localStorage.removeItem(COOKIE_CONSENT_KEY);
};
